import React from 'react';

const TrainDriverCharacter = ({ width = 220, height = 310, style = {} }) => (
  <svg
    viewBox="0 0 220 320"
    width={width}
    height={height}
    style={style}
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <radialGradient id="tdSkin" cx="40%" cy="35%" r="60%">
        <stop offset="0%" stopColor="#f0c898" />
        <stop offset="100%" stopColor="#d48858" />
      </radialGradient>
      <radialGradient id="tdHead" cx="38%" cy="32%" r="65%">
        <stop offset="0%" stopColor="#f2ca9a" />
        <stop offset="55%" stopColor="#e0a870" />
        <stop offset="100%" stopColor="#c07848" />
      </radialGradient>
      <linearGradient id="tdUniform" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#1e3a72" />
        <stop offset="55%" stopColor="#152d5a" />
        <stop offset="100%" stopColor="#0d1e40" />
      </linearGradient>
      <linearGradient id="tdPants" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#1a3268" />
        <stop offset="100%" stopColor="#0c1e44" />
      </linearGradient>
      <linearGradient id="tdShoe" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#181818" />
        <stop offset="100%" stopColor="#080808" />
      </linearGradient>
      <linearGradient id="tdGold" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#f2cc42" />
        <stop offset="55%" stopColor="#d4a820" />
        <stop offset="100%" stopColor="#a87810" />
      </linearGradient>
      <radialGradient id="tdCap" cx="35%" cy="30%" r="65%">
        <stop offset="0%" stopColor="#264880" />
        <stop offset="60%" stopColor="#1a3268" />
        <stop offset="100%" stopColor="#0e2048" />
      </radialGradient>
      <radialGradient id="tdWatch" cx="38%" cy="32%" r="65%">
        <stop offset="0%" stopColor="#f5d870" />
        <stop offset="55%" stopColor="#d4a820" />
        <stop offset="100%" stopColor="#987010" />
      </radialGradient>
      <filter id="tdDrop" x="-20%" y="-20%" width="140%" height="140%">
        <feDropShadow dx="2" dy="4" stdDeviation="3" floodOpacity="0.25" />
      </filter>
    </defs>

    {/* Ground shadow */}
    <ellipse cx="110" cy="313" rx="64" ry="9" fill="rgba(0,0,0,0.22)" />

    {/* === SHOES === */}
    <ellipse cx="88" cy="304" rx="26" ry="10" fill="url(#tdShoe)" stroke="#040404" strokeWidth="2" />
    <ellipse cx="88" cy="300" rx="24" ry="7" fill="#222" />
    <path d="M 65 302 Q 70 294 94 297 Q 103 299 101 305 Q 82 309 65 302 Z" fill="#2a2a2a" />
    <ellipse cx="82" cy="298" rx="9" ry="3" fill="rgba(255,255,255,0.09)" transform="rotate(-10,82,298)" />
    <ellipse cx="130" cy="306" rx="26" ry="10" fill="url(#tdShoe)" stroke="#040404" strokeWidth="2" />
    <ellipse cx="130" cy="302" rx="24" ry="7" fill="#222" />
    <path d="M 107 304 Q 112 296 136 299 Q 145 301 143 307 Q 124 311 107 304 Z" fill="#2a2a2a" />
    <ellipse cx="124" cy="300" rx="9" ry="3" fill="rgba(255,255,255,0.09)" transform="rotate(-10,124,300)" />

    {/* === PANTS === */}
    <path d="M 84 250 Q 78 269 76 289 Q 80 298 98 297 Q 107 295 106 285 Q 103 268 100 250 Z"
      fill="url(#tdPants)" stroke="#0a1228" strokeWidth="2" />
    <path d="M 88 252 Q 84 271 82 286" stroke="rgba(80,120,200,0.18)" strokeWidth="2" fill="none" strokeLinecap="round" />
    <path d="M 118 250 Q 122 269 124 286 Q 128 296 142 294 Q 150 292 148 282 Q 145 267 140 250 Z"
      fill="url(#tdPants)" stroke="#0a1228" strokeWidth="2" />
    <path d="M 138 252 Q 141 270 141 283" stroke="rgba(80,120,200,0.18)" strokeWidth="2" fill="none" strokeLinecap="round" />

    {/* === UNIFORM JACKET === */}
    <path d="M 60 138 Q 50 166 48 208 Q 47 232 54 250 L 172 250 Q 179 232 178 208 Q 176 166 166 138 Z"
      fill="url(#tdUniform)" stroke="#0a1228" strokeWidth="2.5" />
    {/* Jacket shade */}
    <path d="M 60 138 Q 52 166 50 208 Q 49 232 54 250 L 110 250 L 110 138 Z" fill="rgba(0,0,0,0.13)" />
    {/* White shirt / collar */}
    <path d="M 98 136 L 86 160 L 110 167 L 134 160 L 122 136 Z" fill="#f8f8f8" stroke="#ddd" strokeWidth="1" />
    {/* Tie — black/navy */}
    <path d="M 106 136 L 114 136 L 118 178 L 110 187 L 102 178 Z" fill="#111826" stroke="#090f1c" strokeWidth="1.5" />
    <path d="M 107 138 L 113 138 L 111 156 L 109 156 Z" fill="#1e2e48" />
    {/* Lapel lines */}
    <path d="M 110 136 Q 80 156 70 208" fill="none" stroke="#2a4a90" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M 110 136 Q 140 156 150 208" fill="none" stroke="#2a4a90" strokeWidth="1.5" strokeLinecap="round" />

    {/* === GOLD BUTTONS === */}
    <circle cx="110" cy="176" r="4.2" fill="url(#tdGold)" stroke="#907010" strokeWidth="1" />
    <circle cx="110" cy="194" r="4.2" fill="url(#tdGold)" stroke="#907010" strokeWidth="1" />
    <circle cx="110" cy="212" r="4.2" fill="url(#tdGold)" stroke="#907010" strokeWidth="1" />
    <circle cx="110" cy="230" r="4.2" fill="url(#tdGold)" stroke="#907010" strokeWidth="1" />
    <circle cx="109" cy="175" r="1.8" fill="rgba(255,250,190,0.75)" />
    <circle cx="109" cy="193" r="1.8" fill="rgba(255,250,190,0.75)" />
    <circle cx="109" cy="211" r="1.8" fill="rgba(255,250,190,0.75)" />
    <circle cx="109" cy="229" r="1.8" fill="rgba(255,250,190,0.75)" />

    {/* === EPAULETTES — 3 gold stripes (senior rank) === */}
    <rect x="48" y="138" width="28" height="11" rx="3" fill="url(#tdGold)" stroke="#907010" strokeWidth="1.5" />
    <line x1="52" y1="142" x2="72" y2="142" stroke="#c09020" strokeWidth="1.2" />
    <line x1="52" y1="145" x2="72" y2="145" stroke="#c09020" strokeWidth="1.2" />
    <line x1="52" y1="148" x2="72" y2="148" stroke="#c09020" strokeWidth="1.2" />
    <rect x="144" y="138" width="28" height="11" rx="3" fill="url(#tdGold)" stroke="#907010" strokeWidth="1.5" />
    <line x1="148" y1="142" x2="168" y2="142" stroke="#c09020" strokeWidth="1.2" />
    <line x1="148" y1="145" x2="168" y2="145" stroke="#c09020" strokeWidth="1.2" />
    <line x1="148" y1="148" x2="168" y2="148" stroke="#c09020" strokeWidth="1.2" />

    {/* === JR COMPANY BADGE — left chest === */}
    <rect x="62" y="170" width="27" height="22" rx="3" fill="#eef2ff" stroke="#3a5a9a" strokeWidth="1.5" />
    <rect x="62" y="170" width="27" height="8" rx="2" fill="#1a3268" />
    <text x="75.5" y="178" textAnchor="middle" fontSize="6" fill="#f2cc42" fontFamily="Arial, sans-serif" fontWeight="bold">JR</text>
    <text x="75.5" y="186" textAnchor="middle" fontSize="4.5" fill="#6070a0" fontFamily="Arial, sans-serif">新幹線</text>
    <line x1="66" y1="188" x2="85" y2="188" stroke="#8090c0" strokeWidth="0.8" />

    {/* === ARMS === */}
    {/* Left arm — hanging naturally */}
    <path d="M 63 146 Q 45 169 41 205 Q 40 216 47 220"
      fill="none" stroke="#0a1228" strokeWidth="24" strokeLinecap="round" opacity="0.14" />
    <path d="M 63 146 Q 45 169 41 205 Q 40 216 47 220"
      fill="none" stroke="#1e3a72" strokeWidth="20" strokeLinecap="round" />
    {/* Gold cuff band */}
    <path d="M 41 209 Q 40 216 47 220" stroke="url(#tdGold)" strokeWidth="23" fill="none" strokeLinecap="round" />
    <path d="M 41 209 Q 40 216 47 220" stroke="#1e3a72" strokeWidth="18" fill="none" strokeLinecap="round" />
    <path d="M 41 209 Q 40 216 47 220" stroke="url(#tdGold)" strokeWidth="2" fill="none" strokeLinecap="round" />
    {/* White gloved left hand */}
    <ellipse cx="46" cy="221" rx="11" ry="9" fill="#f0f0ec" stroke="#d0d0ca" strokeWidth="1.5" />
    <path d="M 37 220 Q 43 226 57 222" fill="none" stroke="#c8c8c2" strokeWidth="1.5" strokeLinecap="round" />

    {/* Right arm — extended holding watch */}
    <path d="M 157 146 Q 174 168 177 200 Q 177 212 173 218"
      fill="none" stroke="#0a1228" strokeWidth="24" strokeLinecap="round" opacity="0.14" />
    <path d="M 157 146 Q 174 168 177 200 Q 177 212 173 218"
      fill="none" stroke="#1e3a72" strokeWidth="20" strokeLinecap="round" />
    {/* Gold cuff band */}
    <path d="M 177 203 Q 178 212 173 218" stroke="url(#tdGold)" strokeWidth="23" fill="none" strokeLinecap="round" />
    <path d="M 177 203 Q 178 212 173 218" stroke="#1e3a72" strokeWidth="18" fill="none" strokeLinecap="round" />
    <path d="M 177 203 Q 178 212 173 218" stroke="url(#tdGold)" strokeWidth="2" fill="none" strokeLinecap="round" />
    {/* White gloved right hand */}
    <ellipse cx="173" cy="219" rx="11" ry="9" fill="#f0f0ec" stroke="#d0d0ca" strokeWidth="1.5" transform="rotate(-15,173,219)" />

    {/* === POCKET WATCH — held up, face visible === */}
    {/* Watch chain from lapel button */}
    <path d="M 126 178 Q 148 186 162 202 Q 168 210 172 220"
      fill="none" stroke="#d4a820" strokeWidth="2" strokeLinecap="round" strokeDasharray="3,3" />
    {/* Watch case outer rim */}
    <circle cx="186" cy="232" r="22" fill="url(#tdWatch)" stroke="#806010" strokeWidth="2.5" filter="url(#tdDrop)" />
    {/* Watch face */}
    <circle cx="186" cy="232" r="17.5" fill="#fafaf6" stroke="#c09018" strokeWidth="1.5" />
    {/* Inner ring */}
    <circle cx="186" cy="232" r="14" fill="none" stroke="#e8d898" strokeWidth="0.8" />
    {/* Hour tick marks */}
    {[...Array(12)].map((_, i) => {
      const a = (i * 30 - 90) * Math.PI / 180;
      const r1 = i % 3 === 0 ? 9.5 : 11;
      return (
        <line key={i}
          x1={186 + r1 * Math.cos(a)} y1={232 + r1 * Math.sin(a)}
          x2={186 + 13.5 * Math.cos(a)} y2={232 + 13.5 * Math.sin(a)}
          stroke="#2a1808" strokeWidth={i % 3 === 0 ? 2.2 : 1.2} strokeLinecap="round" />
      );
    })}
    {/* Hour hand — pointing straight up (12:00 exact) */}
    <line x1="186" y1="232" x2="186" y2="220" stroke="#1a1208" strokeWidth="3" strokeLinecap="round" />
    {/* Minute hand — pointing straight up too */}
    <line x1="186" y1="232" x2="186" y2="218" stroke="#1a1208" strokeWidth="2" strokeLinecap="round" />
    {/* Seconds hand — pointing to 3 */}
    <line x1="186" y1="232" x2="198" y2="232" stroke="#c02020" strokeWidth="1.2" strokeLinecap="round" />
    {/* Center jewel */}
    <circle cx="186" cy="232" r="3" fill="url(#tdGold)" stroke="#806010" strokeWidth="1" />
    <circle cx="186" cy="232" r="1.5" fill="#f5e060" />
    {/* Watch crown / winder */}
    <rect x="202" y="229" width="8" height="6" rx="2" fill="url(#tdGold)" stroke="#806010" strokeWidth="1" />
    {/* Outer case highlight */}
    <path d="M 174 220 Q 178 215 184 217" fill="none" stroke="rgba(255,250,180,0.65)" strokeWidth="2.5" strokeLinecap="round" />
    {/* Case rim shine */}
    <circle cx="186" cy="232" r="22" fill="none" stroke="rgba(255,240,150,0.3)" strokeWidth="4" />

    {/* === NECK === */}
    <rect x="97" y="118" width="26" height="24" rx="10" fill="url(#tdSkin)" stroke="#b07040" strokeWidth="2" />
    <line x1="110" y1="120" x2="110" y2="140" stroke="rgba(160,100,40,0.18)" strokeWidth="1.5" />

    {/* === HEAD === */}
    <ellipse cx="110" cy="82" rx="52" ry="56" fill="url(#tdHead)" stroke="#111" strokeWidth="2.5" filter="url(#tdDrop)" />
    <ellipse cx="94" cy="62" rx="22" ry="18" fill="rgba(255,255,255,0.18)" transform="rotate(-20,94,62)" />
    <ellipse cx="110" cy="128" rx="28" ry="10" fill="rgba(0,0,0,0.1)" />

    {/* === HAIR — black, short sides visible === */}
    <path d="M 60 72 Q 62 28 110 24 Q 158 28 160 72 Q 145 44 110 42 Q 75 44 60 72 Z"
      fill="#141010" stroke="#0a0808" strokeWidth="1.5" />
    <path d="M 60 72 Q 54 86 56 103 Q 60 88 66 90 Z" fill="#141010" />
    <path d="M 160 72 Q 166 86 164 103 Q 160 88 154 90 Z" fill="#141010" />

    {/* === PEAKED CAP === */}
    {/* Cap band (around head) */}
    <rect x="56" y="56" width="108" height="24" rx="4" fill="#162e5a" stroke="#0a1a38" strokeWidth="2" />
    {/* Gold band stripe */}
    <rect x="56" y="64" width="108" height="7" fill="url(#tdGold)" />
    {/* Cap crown */}
    <path d="M 62 58 Q 64 18 110 14 Q 156 18 158 58 Q 140 38 110 36 Q 80 38 62 58 Z"
      fill="url(#tdCap)" stroke="#0a1a38" strokeWidth="1.5" />
    {/* Crown highlight (subtle sheen) */}
    <ellipse cx="93" cy="30" rx="18" ry="10" fill="rgba(100,160,255,0.16)" transform="rotate(-15,93,30)" />
    {/* Peaked brim — dark, shiny */}
    <path d="M 56 76 Q 58 88 110 92 Q 162 88 164 76 L 164 80 Q 162 94 110 98 Q 58 94 56 80 Z"
      fill="#1a3268" stroke="#0a1228" strokeWidth="1.5" />
    {/* Brim gloss shine */}
    <path d="M 62 81 Q 110 88 158 81" fill="none" stroke="rgba(80,140,255,0.22)" strokeWidth="2.5" strokeLinecap="round" />
    {/* JR badge — circular, center of cap */}
    <circle cx="110" cy="40" r="13" fill="url(#tdGold)" stroke="#806010" strokeWidth="2" />
    <circle cx="110" cy="40" r="10" fill="#1a3268" stroke="#806010" strokeWidth="1" />
    {/* Badge wreath decoration */}
    <path d="M 100 46 Q 97 40 100 34" fill="none" stroke="#d4a820" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M 120 34 Q 123 40 120 46" fill="none" stroke="#d4a820" strokeWidth="1.5" strokeLinecap="round" />
    <text x="110" y="44" textAnchor="middle" fontSize="8" fill="#f2cc42" fontFamily="Arial, sans-serif" fontWeight="bold">JR</text>
    {/* Chin strap (decorative) */}
    <path d="M 58 82 Q 56 95 60 104" stroke="url(#tdGold)" strokeWidth="2.5" fill="none" strokeLinecap="round" />
    <path d="M 162 82 Q 164 95 160 104" stroke="url(#tdGold)" strokeWidth="2.5" fill="none" strokeLinecap="round" />

    {/* === EARS === */}
    <ellipse cx="58" cy="86" rx="10" ry="13" fill="url(#tdSkin)" stroke="#b07040" strokeWidth="2" />
    <path d="M 60 78 Q 55 86 60 94" fill="none" stroke="#b07040" strokeWidth="1.5" strokeLinecap="round" />
    <ellipse cx="162" cy="86" rx="10" ry="13" fill="url(#tdSkin)" stroke="#b07040" strokeWidth="2" />
    <path d="M 160 78 Q 165 86 160 94" fill="none" stroke="#b07040" strokeWidth="1.5" strokeLinecap="round" />

    {/* === EYEBROWS — dark, precise === */}
    <path d="M 80 66 Q 90 60 100 64" fill="none" stroke="#181010" strokeWidth="3.2" strokeLinecap="round" />
    <path d="M 120 64 Q 130 60 140 66" fill="none" stroke="#181010" strokeWidth="3.2" strokeLinecap="round" />

    {/* === EYES — dark, slightly almond-shaped === */}
    <path d="M 80 80 Q 88 72 96 77 Q 97 87 88 88 Q 79 88 80 80 Z" fill="white" stroke="#222" strokeWidth="1.2" />
    <path d="M 124 80 Q 132 72 140 77 Q 141 87 132 88 Q 123 88 124 80 Z" fill="white" stroke="#222" strokeWidth="1.2" />
    {/* Dark brown irises */}
    <circle cx="88" cy="81" r="6.5" fill="#281408" />
    <circle cx="132" cy="81" r="6.5" fill="#281408" />
    {/* Pupils */}
    <circle cx="88" cy="82" r="4" fill="#0e0808" />
    <circle cx="132" cy="82" r="4" fill="#0e0808" />
    {/* Shines */}
    <circle cx="90" cy="79" r="2.2" fill="white" />
    <circle cx="134" cy="79" r="2.2" fill="white" />
    <circle cx="87" cy="84" r="1" fill="rgba(255,255,255,0.5)" />
    <circle cx="131" cy="84" r="1" fill="rgba(255,255,255,0.5)" />
    {/* Upper eyelid line */}
    <path d="M 80 80 Q 88 75 96 79" fill="none" stroke="#180a08" strokeWidth="1.8" strokeLinecap="round" />
    <path d="M 124 79 Q 132 75 140 80" fill="none" stroke="#180a08" strokeWidth="1.8" strokeLinecap="round" />

    {/* === NOSE === */}
    <path d="M 110 91 Q 104 102 102 106 Q 110 110 118 106 Q 116 102 110 91" fill="#d8946a" />
    <path d="M 103 106 Q 110 110 117 106" fill="none" stroke="#b07040" strokeWidth="2" strokeLinecap="round" />

    {/* === MOUTH — firm, disciplined === */}
    <path d="M 95 116 Q 110 123 125 116" fill="none" stroke="#9a5828" strokeWidth="2.8" strokeLinecap="round" />
    <path d="M 98 117 Q 110 121 122 117 Q 110 120 98 117 Z" fill="white" opacity="0.65" />

    {/* Subtle cheek tone */}
    <ellipse cx="78" cy="100" rx="12" ry="8" fill="rgba(200,100,60,0.15)" />
    <ellipse cx="142" cy="100" rx="12" ry="8" fill="rgba(200,100,60,0.15)" />
  </svg>
);

export default TrainDriverCharacter;
